import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  hasAccess: {
    id: 'proforma-form-security.common.ui.principal-list.principal-item.has-access',
    defaultMessage: 'Has access',
    description: 'Text in the form permission list indicating the user/group can access the submitted form.'
  },
  noAccess: {
    id: 'proforma-form-security.common.ui.principal-list.principal-item.no-access',
    defaultMessage: 'No access',
    description: 'Text in the form permission list indicating the user/group cannot access the submitted form.'
  },
  remove: {
    id: 'proforma-form-security.common.ui.principal-list.principal-item.remove',
    defaultMessage: 'Remove',
    description: 'Text for the button in the form permission list allowing the user to remove the user/group.'
  },
  removeLabel: {
    id: 'proforma-form-security.common.ui.principal-list.principal-item.remove-label',
    defaultMessage: 'Remove form access for {principalName}',
    description: 'Label for the button in the form permission list allowing the user to remove the user/group.'
  }
});